import { useMutation } from "@tanstack/react-query";

import { useToasts } from "app/pages/activation/hooks/helpers/useToasts";
import { translate } from "app/filters/i18nFilter";
import { COMMON_API_ERROR_MESSAGE } from "app/pages/activation/constants/texts";
import { createActivationApi } from "app/pages/activation/services/api";

export const useSwitchFavorite = () => {
    const { showErrorToast } = useToasts();

    return useMutation({
        mutationFn: (activationId: string) => {
            const api = createActivationApi();

            return api.activation.switchFavorite(activationId);
        },
        onError(error: Error) {
            showErrorToast(translate(COMMON_API_ERROR_MESSAGE, { error: error?.message }));
        },
    });
};
